import React from 'react';
import Spinner from 'react-spinkit';
import { Tooltip } from 'react-tooltip';
//interface
import { TextButtonProps } from './interface';
//components
import Text from 'components/Text';
import { Row } from 'components/Layout/Grid';
import { useCustomEvent } from 'components/ApplicationInsights';
//utils
import { generateRandomId } from 'utils/GenerateRandomId';

const TextButton: React.FC<TextButtonProps> = (props) => {
  const {
    tooltip,
    toolTipPlace,
    className,
    onSendRequest,
    loading,
    trackName,
    trackAction,
    disabled,
    title,
    img
  } = props;

  const trackMenuClick = useCustomEvent('Button', trackName);
  const tooltipId = generateRandomId("ReactTooltip");

  const envRequest = () => {
    trackAction && trackMenuClick({ item: trackAction });
    onSendRequest && onSendRequest();
  };

  return (
    <>
      <button
        data-tooltip-content={tooltip || undefined}
        data-tooltip-id={tooltipId}
        data-tooltip-place={toolTipPlace || 'top'}
        className={`button ${className}`}
        disabled={disabled || loading}
        onClick={envRequest}
      >
        {loading ? (
          <Spinner
            name="circle"
            className="color-primary"
            color="color-primary"
            fadeIn="none"
          />
        ) : (
          <>
            <Row>
              {img && <img src={img} />}
              <Text className={`color-primary ${img && 'ml-1'}`} size={12}>{title}</Text>
            </Row>
          </>
        )}
      </button>

      {tooltip && <Tooltip id={tooltipId} variant="light" />}
    </>
  );
};

export default TextButton;